<p-table [value]="tableData" [scrollable]="true" [scrollHeight]="scrollHeight">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th [style.width.px]="130" *ngFor="let col of tableCols">
        {{ col.label }}
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td [style.width.px]="130" *ngFor="let col of tableCols; let i = index">
        <span *ngIf="col.type === 'string'">
          {{ rowData[col.field] }}
        </span>

        <span *ngIf="col.type === 'date'">
          {{ rowData[col.field] }}
        </span>

        <span *ngIf="col.type === 'number'">
          {{ rowData[col.field] | numberFormatter }}
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
